/* @flow */
/* eslint-disable babel/no-invalid-this */
import followLink from "nexia_mobile/models/followLink";
import type { XR724WifiConfigurationFeature } from "./types";

export default function XR724WifiConfiguration(
  feature: XR724WifiConfigurationFeature
) {
  this.fetchLastUpdateTime = () => {
    return followLink(this, feature.get_last_update_time, {
      silent: true,
    }).then((data) => data.last_update_time && new Date(data.last_update_time));
  };

  return {};
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/xr724_wifi_configuration.js